export const environment = {
  production: true,
  database: {
    host: 'admin.netra.hu'
  }
};
